module.exports = __webpack_public_path__ + "static/cathy_portfolio_pic-e53ed60b87533ef481a81f55285fbcc6.png";